import { useState } from 'react'

import { Box, Tabs, Text } from '@factorialco/deprecated-design-system'
import {
  AllocationFragment,
  BudgetFragment,
  BudgetMovementFragment,
  EmployeesTeamsQuery,
  ExpenseCategoryFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import EmployeesTab from './Employees'
import SpendingsTab from './Spendings'
import Tab from './Tab'

type TeamsTeam = EmployeesTeamsQuery['teams']['teams'][number]

interface BudgetTabsProps {
  teams: TeamsTeam[]
  budget: BudgetFragment
  currency: string
  movements: BudgetMovementFragment[]
  categories: ExpenseCategoryFragment[]
  periodStart?: string
  periodEnd?: string
  openEmployeeModal: () => void
  allocations: AllocationFragment[]
  refetchBudget: (param: { id: string; periodStart: string }) => void
}

const TABS = {
  SPENDINGS: 'spendings',
  EMPLOYEES: 'employees',
}

const BudgetTabs = ({
  teams,
  budget,
  currency,
  movements,
  categories,
  periodStart,
  periodEnd,
  openEmployeeModal,
  allocations,
  refetchBudget,
}: BudgetTabsProps) => {
  const [tab, setTab] = useState(TABS.SPENDINGS)

  const goToRecordsTab = () => {
    setTab(TABS.SPENDINGS)
  }

  return (
    <Box gap="s24">
      <Text.Header2>{i18n.t('budgets.detail.tabs.title')}</Text.Header2>
      <Tabs currentId={tab} onTabClicked={(tabId) => setTab(tabId)}>
        <Tabs.Tab id={TABS.SPENDINGS} label={i18n.t('budgets.detail.tabs.spendings.title')}>
          <Tab>
            <SpendingsTab
              movements={movements}
              categories={categories}
              periodStart={periodStart || budget.periodStart}
              periodEnd={periodEnd}
            />
          </Tab>
        </Tabs.Tab>
        <Tabs.Tab id={TABS.EMPLOYEES} label={i18n.t('budgets.detail.tabs.employees.title')}>
          <Tab>
            <EmployeesTab
              // everytime we change allocations we want this datatable to re-render
              key={JSON.stringify(allocations)}
              teams={teams}
              currency={currency}
              openEmployeeModal={openEmployeeModal}
              periodStart={periodStart || budget.periodStart}
              periodEnd={periodEnd}
              budget={budget}
              goToRecordsTab={goToRecordsTab}
              allocations={allocations}
              refetchBudget={refetchBudget}
            />
          </Tab>
        </Tabs.Tab>
      </Tabs>
    </Box>
  )
}

export default BudgetTabs
